import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import mixins from './mixins'

// 按需引入 echarts 5.x
import echarts from "./utils/echarts";
Vue.prototype.$echarts = echarts;

//导入md5.js
// import MD5 from "js-md5"
// Vue.prototype.md5 = MD5
Vue.mixin( mixins )

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
